import { Storage } from '@microsoft/office-js-helpers'
import history from './configureHistory'

// file contains quirks and fixes to allow user to return to the last url after login

export const BACK_PATH = 'backPath'

let historyStorageInstance: Storage<string | boolean>

if (typeof document !== 'undefined') {
  historyStorageInstance = new Storage('there-and-back-again')
}

export function getBack(): void {
  const path = historyStorageInstance?.get(BACK_PATH)
  if (typeof path !== 'string') {
    return
  }
  history.push(path)
  historyStorageInstance?.delete(BACK_PATH)
}

export function setBackPath(backPath = history.location.pathname): void {
  historyStorageInstance?.set(BACK_PATH, backPath)
}

export function getBackPath(): string | unknown {
  return historyStorageInstance?.get(BACK_PATH)
}
